import { computed, inject, provide, ref } from '@vue/composition-api'

export const SOURCES = Symbol('sourcesSymbol')
export const SOURCE_DATA = Symbol('sourceDataSymbol')
export const LOCAL_SOURCE_DATA = Symbol('sourceLocalDataSymbol')
export const LOCAL_SOURCE = Symbol('sourceLocalSymbol')

export default function useDataSources ({ overrideLocalSources = false } = {}) {
  const sources = inject(SOURCES, ref([]))
  provide(SOURCES, sources)

  const sourceData = inject(SOURCE_DATA, ref({}))
  provide(SOURCE_DATA, sourceData)

  let localDataSources = ref({})
  let localSources = ref([])

  if (!overrideLocalSources) {
    localSources = inject(LOCAL_SOURCE, ref([]))
    localDataSources = inject(LOCAL_SOURCE_DATA, ref({}))
  }

  provide(LOCAL_SOURCE_DATA, localDataSources)
  provide(LOCAL_SOURCE, localSources)

  function addSources (sourceOrSources) {
    const sourcesList = Array.isArray(sourceOrSources) ? sourceOrSources : [ sourceOrSources ]
    sources.value.push(...sourcesList)
  }
  function prependSources (sourceOrSources) {
    const sourcesList = Array.isArray(sourceOrSources) ? sourceOrSources : [ sourceOrSources ]
    sources.value.unshift(...sourcesList)
  }

  function prependLocalSources (sourceOrSources) {
    const sourcesList = Array.isArray(sourceOrSources) ? sourceOrSources : [ sourceOrSources ]
    localSources.value.unshift(...sourcesList)
  }
  function addLocalSources (sourceOrSources) {
    const sourcesList = Array.isArray(sourceOrSources) ? sourceOrSources : [ sourceOrSources ]
    localSources.value.push(...sourcesList)
  }

  function addSourceData (source, data) {
    sourceData.value[source] = data
  }

  function addLocalSourceData (source, data) {
    localDataSources.value[source] = data
  }

  const mergedSourcesData = computed(() => ({
    ...sourceData.value,
    ...localDataSources.value,
  }))

  const mergedSources = computed(() => [
    ...localSources.value,
    ...sources.value,
  ])

  return {
    sources: mergedSources,
    sourceData: mergedSourcesData,
    localDataSources,
    addSources,
    addLocalSources,
    prependLocalSources,
    prependSources,
    addSourceData,
    addLocalSourceData,
  }
}
